import { Injectable } from '@angular/core';

import { initializeApp, getApps } from 'firebase/app';
import { getRemoteConfig, fetchAndActivate, getValue, RemoteConfig } from 'firebase/remote-config';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class RemoteConfigService {
  private remoteConfig: RemoteConfig;
  private maintenanceCache: boolean = false;
  private maintenanceCacheTime: number = 0;
  private maintenanceCacheDuration: number = 120000; // 2 minutes

  constructor() {
    // Prevent re-initialization if already initialized
    const app = getApps().length ? getApps()[0] : initializeApp(environment.firebaseConfig);
    this.remoteConfig = getRemoteConfig(app);
    this.remoteConfig.settings = {
      minimumFetchIntervalMillis: 0, // 0 for instant updates
      fetchTimeoutMillis: 60000            // 1 minute (or any value in ms)
    };
  }

  async getAnnouncements(): Promise<string> {
    await fetchAndActivate(this.remoteConfig);
    const value = getValue(this.remoteConfig, 'ANNOUNCEMENTS');
    return value.asString();
  }

  async getMaintenanceAdmin(): Promise<boolean> {
    await fetchAndActivate(this.remoteConfig);
    const value = getValue(this.remoteConfig, 'MAINTENANCE_ADMIN');
    return value.asBoolean();
  }

  async getMaintenanceMessage(): Promise<string | null> {
    try {
      await fetchAndActivate(this.remoteConfig);
      const value = getValue(this.remoteConfig, 'MAINTENANCE_MESSAGE');
      return value.asString() || null;
    } catch {
      return null;
    }
  }

  async isMaintenanceCached(): Promise<boolean> {
    const now = Date.now();
    if (now - this.maintenanceCacheTime < this.maintenanceCacheDuration) {
      return this.maintenanceCache;
    }
    try {
      await fetchAndActivate(this.remoteConfig);
      const value = getValue(this.remoteConfig, 'MAINTENANCE_ADMIN');
      this.maintenanceCache = value.asBoolean();
      this.maintenanceCacheTime = now;
      return this.maintenanceCache;
    } catch (error) {
      console.error('isMaintenanceCached error:', error);
      return false;
    }
  }
} 